"use strict";

module.exports = {
	List: require('./Agents'),
	AddEdit: require('./AgentAddEdit'),
	Leads: require('./AgentLeads'),
	EmailTools: require('./email-tools')
};